<template>
	<div class="root-wrap">
		<!-- <div class="header-wrap">
            <Header type="light" round></Header>
        </div> -->

		<div class="body-wrap fx-fill">
			<div class="fill-box" v-if="widData.length > 0">
				<div v-for="(item, index) in widData" :key="item.widgetId">
					<div v-if="item.widgetType == 'dy_zzry'" class="movie-item-wrap">
						<div class="fx-row fx-between">
							<div style="font-size: 15px">正在热映</div>
							<div class="fc-tips" @click="goScroll(1)">
								全部({{ hotMovieList.total }})
							</div>
						</div>
						<div class="movie_tab-wrap">
							<movie-list
								:list="hotMovieList.data"
								@buy="buyTicket"
								@detail="goDetail"
							></movie-list>
						</div>
					</div>
					<div v-else-if="item.widgetType == 'dy_jjsy'" class="movie-item-wrap">
						<div class="fx-row fx-between">
							<div style="font-size: 15px">即将上映</div>
							<div class="fc-tips" @click="goScroll(2)">
								全部({{ futureMovieList ? futureMovieList.total : "" }})
							</div>
						</div>
						<div class="movie_tab-wrap">
							<movie-list
								:list="futureMovieList.data"
								type="future"
								@detail="goDetail"
							></movie-list>
						</div>
					</div>
					<div v-else-if="item.widgetType == 'dy_tjyy'" class="movie-item-wrap">
						<div class="fx-row fx-between">
							<div style="font-size: 15px">推荐影院</div>
							<div class="fc-tips" @click="$goPage('cinema')">全部影院 ></div>
						</div>
						<div style="margin-top: 10px">
							<Nearby
								v-for="(item, index) of cinemaList"
								:key="index"
								:no="index + 1"
								:data="item"
								@on-click="toCinema"
							></Nearby>
						</div>
					</div>
					<div v-else-if="item.widgetType == 'dy_tpgg'" class="movie-item-wrap">
						<van-swipe
							class="my-swipe"
							:autoplay="4000"
							indicator-color="white"
						>
							<van-swipe-item v-for="(img, index) in item.list" :key="index">
								<img
									@click="toTemp(img)"
									:src="img.picUrl"
									:style="{
										width: 100 + '%',
										height: item.picScalePx + 'px',
										'border-radius': item.picStyle === '圆形' ? '8px' : '',
									}"
								/>
							</van-swipe-item>
						</van-swipe>
					</div>
					<div v-else-if="item.widgetType == 'dy_ztdh'" class="movie-item-wrap">
						<div
							style="
								display: flex;
								flex-wrap: wrap;
								justify-content: space-around;
							"
							v-if="item.displayStyle === '平铺'"
						>
							<div
								v-for="(img, index) in item.list"
								:key="index"
								:style="{
									'text-align': 'center',
									'margin-bottom': '10px',
									width:
										item.displayCount === '一行4个' ||
										item.displayCount === '两行8个'
											? '20.1%'
											: '17%',
								}"
							>
								<img
									@click="toTemp(img)"
									:src="img.picUrl"
									:style="{
										'border-radius': item.picStyle == '圆形' ? '100%' : '',
									}"
									:class="{
										'ztdh-img': true,
										'ztdh-zsy': item.picScale == '自适应宽高',
										'ztdh-zd': item.picScale == '中等',
										'ztdh-xs': item.picScale == '小型',
									}"
								/>
								<div
									:class="{ 'fs-13': item.picScale == '小型' }"
									style="text-align: center"
								>
									{{ img.picName }}
								</div>
							</div>
						</div>
						<div v-else style="display: flex">
							<div
								v-for="(img, index) in item.list"
								:key="index"
								style="
									display: inline-block;
									width: 23%;
									text-align: center;
									margin-right: 10px;
								"
							>
								<img
									@click="toTemp(img)"
									:src="img.picUrl"
									:style="{
										'border-radius': item.picStyle == '圆形' ? '100%' : '',
									}"
									:class="{
										'ztdh-zsy': item.picScale == '自适应宽高',
										'ztdh-zd': item.picScale == '中等',
										'ztdh-xs': item.picScale == '小型',
									}"
								/>
								<div
									:class="{ 'fs-12': item.picScale == '小型' }"
									style="text-align: center"
								>
									{{ img.picName }}
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="item.widgetType == 'dy_tbdh'" class="movie-item-wrap">
						<div
							v-if="item.displayCount === '双排'"
							style="background-color: #fff"
						>
							<img
								@click="toTemp(item.list[0])"
								:src="item.list[0].picUrl"
								class="tbdh-sp"
								style="margin-right: 0px"
							/>
							<img
								@click="toTemp(item.list[1])"
								:src="item.list[1].picUrl"
								class="tbdh-sp"
							/>
						</div>
						<div
							v-else-if="item.displayCount === '四宫格'"
							style="background-color: #fff"
						>
							<img
								@click="toTemp(item.list[0])"
								:src="item.list[0].picUrl"
								class="tbdh-sp"
								style="margin-right: 0px"
							/>
							<img
								@click="toTemp(item.list[1])"
								:src="item.list[1].picUrl"
								class="tbdh-sp"
							/>
							<img
								@click="toTemp(item.list[2])"
								:src="item.list[2].picUrl"
								class="tbdh-sp"
								style="margin-right: 0px; margin-top: 0px"
							/>
							<img
								@click="toTemp(item.list[3])"
								:src="item.list[3].picUrl"
								style="margin-top: 0px"
								class="tbdh-sp"
							/>
						</div>
						<div v-else-if="item.displayCount == '三宫格'">
							<div class="tbdh-sgg">
								<div class="mr-6">
									<img
										:src="item.list[0].picUrl"
										@click="toTemp(item.list[0])"
										class="tbdh-sgg-img"
									/>
								</div>
								<div class="mr-6">
									<div>
										<img
											class="tbdh-sgg-img"
											@click="toTemp(item.list[1])"
											:src="item.list[1].picUrl"
										/>
									</div>
								</div>
								<div>
									<img
										class="tbdh-sgg-img"
										@click="toTemp(item.list[2])"
										:src="item.list[2].picUrl"
									/>
								</div>
							</div>
						</div>
						<div v-else-if="item.displayCount == '三拼'">
							<div class="tbdh-sgg">
								<div class="tbdh-spp">
									<img
										:src="item.list[0].picUrl"
										@click="toTemp(item.list[0])"
										class="tbdh-sp-img-left"
									/>
								</div>

								<div style="width: 50%">
									<div>
										<div>
											<img
												class="tbdh-sp-img-right"
												@click="toTemp(item.list[1])"
												:src="item.list[1].picUrl"
											/>
										</div>
									</div>
									<div>
										<img
											@click="toTemp(item.list[2])"
											class="tbdh-sp-img-right"
											:src="item.list[2].picUrl"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						style="height: 60px"
						v-if="widData.length == index + 1 && mallInfo.mallType == 1"
					></div>
				</div>
			</div>
			<div class="fill-box" v-else>
				<div class="movie-item-wrap">
					<div class="fx-row fx-between">
						<div style="font-size: 15px">正在热映</div>
						<div class="fc-tips" @click="goScroll(1)">
							全部({{ hotMovieList.total }})
						</div>
					</div>
					<div class="movie_tab-wrap">
						<movie-list
							:list="hotMovieList.data"
							@buy="buyTicket"
							@detail="goDetail"
						></movie-list>
					</div>
				</div>
				<div class="movie-item-wrap">
					<div class="fx-row fx-between">
						<div style="font-size: 15px">即将上映</div>
						<div class="fc-tips" @click="goScroll(2)">
							全部({{ futureMovieList ? futureMovieList.total : "" }})
						</div>
					</div>
					<div class="movie_tab-wrap">
						<movie-list
							:list="futureMovieList.data"
							type="future"
							@detail="goDetail"
						></movie-list>
					</div>
				</div>
				<div class="movie-item-wrap">
					<div class="fx-row fx-between">
						<div style="font-size: 15px">推荐影院</div>
						<div class="fc-tips" @click="$goPage('cinema')">全部影院 ></div>
					</div>
					<div style="margin-top: 10px">
						<Nearby
							v-for="(item, index) of cinemaList"
							:key="index"
							:no="index + 1"
							:data="item"
							@on-click="toCinema"
						></Nearby>
					</div>
				</div>
			</div>
		</div>

		<van-tabbar
			v-model="active"
			@change="actChange"
			v-if="mallInfo.mallType == 1"
		>
			<van-tabbar-item icon="home-o">首页</van-tabbar-item>
			<van-tabbar-item icon="friends-o">我的</van-tabbar-item>
		</van-tabbar>
		<!-- <div class="footer-wrap">
            <tab-bar></tab-bar>
        </div> -->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { setStore, removeStore } from "@/libs/storage-utils";
import Header from "@/components/header";
import TabBar from "@/components/tab-bar";
import ScreenArea from "@/components/cinema/screen-area";
import MovieList from "@/components/movie/movie-list";
import CinemaTable from "@/components/cinema/cinema-table";
import Nearby from "./nearby";
import {
	movieNow,
	movieSoon,
	cimeraDistance,
	mallWidget,
} from "@/utils/api.js";
export default {
	data() {
		return {
			active: 0,
			widData: [],
			activeIndex: 0,
			hotMovieList: [],
			futureMovieList: [],
			bannerList: [],
			cinemaList: [],
			mallInfo: {},
			pagination: this.$config.getDefaultPagination(),
		};
	},
	computed: {
		...mapGetters([
			"position",
			"currentCityCode",
			"currentCityName",
			"currentCountyCode",
			"currentCountyName",
			"currentCityId",
		]),
		selectedLocation() {
			return this.$store.state.app.selectedLocation;
		},
	},
	// watch: {
	// 	currentCityCode: {
	// 		handler() {
	// 			this.getData();
	// 		},
	// 	},
	// 	position: {
	// 		handler() {
	// 			this.getData();
	// 		},
	// 	},
	// },
	activated() {
		if (sessionStorage.getItem("needReload")) {
			sessionStorage.removeItem("needReload");
			this.getData();
		}
	},
	async created() {
		this.mallInfo = JSON.parse(localStorage.getItem("mallInfo"));
		const res = await mallWidget({ widgetModule: "dy" });
		this.widData = res;

		this.widData.forEach(async (item) => {
			if (item.widgetType === "dy_tpgg") {
				if (item.picScale === "3:2") {
					item.picScalePx = 234;
				} else if (item.picScale === "16:9") {
					item.picScalePx = 198;
				} else if (item.picScale === "4.3:1") {
					item.picScalePx = 82;
				}
			}
		});
	},
	methods: {
		actChange() {
			if (this.active == 1) {
				window.open(
					`${window.location.origin}/shop/?t=${localStorage.getItem("t")}#/my`,
					"_self"
				);
			}
		},
		async toTemp(item) {
			let picType = item.picType || item.adType;
			let picTarget = item.picTarget || item.adTarget;
			if (picType === "spmb") {
				window.open(
					`${window.location.origin}/shop/?t=${localStorage.getItem(
						"t"
					)}#/spmb?tempId=${picTarget}`,
					"_self"
				);
			} else if (picType === "spxq") {
				window.open(
					`${window.location.origin}/shop/?t=${localStorage.getItem(
						"t"
					)}#/goodsDetail?id=${picTarget}`,
					"_self"
				);
			} else if (picType === "wydz") {
				window.open(item.picTarget, "_self");
			}
		},
		goScroll(type) {
			this.$goPage("movie-scroll", {
				type,
			});
		},
		buyTicket(movieId, movieName) {
			this.$goPage("cinema", {
				movieId,
				movieName: movieName,
			});
		},
		goDetail(movieId, movieName) {
			this.$goPage("movie-detail2", {
				movieId,
				movieName,
			});
		},
		async getHotMovieList() {
			let params = {
				citycode: this.currentCityCode,
			};

			// this.$service
			// 	.getHotMovieList(params)
			// 	.then((res) => {
			// 		this.hotMovieList = res.movielist;
			// 	})
			// 	.catch((err) => {
			// 		console.log("请求hotMovieList", err);
			// 	});
		},
		async getFutureMovieList() {
			// this.$service
			// 	.getFutureMovieList(params)
			// 	.then((res) => {
			// 		//	console.log("res22222222", res.movielist);
			// 		this.futureMovieList = res.movielist;
			// 	})
			// 	.catch((err) => {
			// 		console.log("请求future", err);
			// 	});
		},
		async getCinemaList(refresh) {
			if (refresh) {
				this.cinemaList = [];
				this.pagination = this.$config.getDefaultPagination();
			}

			// this.$service
			// 	.getCinemaList(params)
			// 	.then((res) => {
			// 		console.log("res.cinemalist1111", res.cinemalist);
			// 		this.cinemaList = res.cinemalist;
			// 		// this.cinemaList = this.cinemaList.concat(res.cinemalist);
			// 		this.pagination = res.pagination;
			// 		console.log(this.cinemaList);
			// 	})
			// 	.catch((err) => {
			// 		console.log("请求影院", err);
			// 	});
		},
		getBannerList() {
			let params = {
				type: "newwap",
				device: "wxmicro",
				citycode: this.currentCityCode,
			};

			// this.$service
			// 	.getBannerList(params)
			// 	.then((res) => {
			// 		this.bannerList = res.slide;
			// 	})
			// 	.catch((err) => {
			// 		console.log("请求banner", err);
			// 	});
		},
		handleSwipe(item) {
			//TODO
			this.$goPage("cinema", {
				movieId: item.relateid,
			});
		},
		loadMore() {
			if (this.pagination.next) {
				++this.pagination.current_page;
				this.getCinemaList();
			}
		},
		toCinema(cinemaId, cinemaName) {
			this.$goPage("movie-session", {
				cinemaId,
				cinemaName,
			});
		},
		buildPageParams() {
			let params = this.$route.query;
			if (params.flag) {
				//是否使用新的支付页面 flag = new 表示使用新的
				setStore("newPayFlag", params.flag);
			} else {
				console.log("homeIndex -> remove newPayFlag");
				removeStore("newPayFlag");
			}
		},
		getQueryVariable(variable) {
			let query = window.location.search.substring(1);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return false;
		},
		initPage() {
			// if (!this.position) {
			// }
			// this.currentCityCode.splice(3,2)
			this.pagination = this.$config.getDefaultPagination();
			// this.buildPageParams();
			let token = this.getQueryVariable("token");
			// let mallId = this.getQueryVariable("mallId");
			// let tenantId = this.getQueryVariable("tenantId");
			console.log(token);
			console.log((this.currentCityCode + "").split("").splice(0, 4).join(""));
			if (token) {
				setStore("newToken", token);
			}
			// setStore('mallId', mallId);
			// setStore('tenantId', tenantId);
			this.getBannerList();
			this.getHotMovieList();
			this.getFutureMovieList();
			this.getCinemaList(true);
		},
		async getData() {
			let params = {
				cityId: this.currentCityId,
				pageIdx: 1,
				pageSize: 10,
			};
			// 即将上映接口
			this.futureMovieList = [];
			this.hotMovieList = [];
			this.cinemaList = [];
			const res = await movieSoon(params);
			this.futureMovieList = res;
			// 正在热映

			const res2 = await movieNow(params);
			this.hotMovieList = res2;
			let nowTime = new Date().getTime();
			this.hotMovieList.data.forEach((item) => {
				item.publish_date = item.publish_date.replaceAll("-", "/");
				if (new Date(item.publish_date).getTime() < nowTime) {
					item.isBuy = true;
				}
			});
			// 推荐影院
			let params2 = {
				cityId: this.currentCityId,
				countycode: this.currentCountyCode,
				countyName: this.currentCountyName,
				longitude: this.position ? this.position.lng : 121.34,
				latitude: this.position ? this.position.lat : 31.2,
				citycode: this.currentCityCode,
				pageIdx: 1,
				pageSize: 10,
			};
			//  推荐影院接口
			const res3 = await cimeraDistance(params2);
			this.cinemaList = res3.data;
		},
	},
	async mounted() {
		//this.initPage();
		await this.getData();

		this.$store.commit("setSelectedCounty", null);
	},

	beforeRouteLeave(to, from, next) {
		if (to.path == "/city") {
			sessionStorage.setItem("needReload", 1);
		}
		next();
	},
	components: {
		Header,
		TabBar,
		MovieList,
		ScreenArea,
		CinemaTable,
		Nearby,
	},
};
</script>

<style lang="scss" scoped>
.body-wrap {
	position: relative;
	.movie_tab-wrap {
		width: 100%;
		overflow: auto;
	}

	.movie-item-wrap {
		background-color: #fff;
		margin-bottom: 10px;
		padding-left: 8px;
		padding-right: 8px;
		padding-top: 10px;
	}
}
.footer-wrap {
	padding-top: 50px;
}
// 专题导航
.ztdh-img {
	width: 100%;
}
.ztdh-zsy {
	width: 100%;
}
.ztdh-zd {
	width: 60px;
}
.ztdh-xs {
	width: 48px;
}

// 图标导航
.tbdh-sgg {
	display: flex;
	background-color: #fff;
	padding: 6px;
	padding-bottom: 2px;
}
.tbdh-sgg-img {
	width: 100%;
	height: 110px;
}
.mr-6 {
	margin-right: 6px;
}
.tbdh-sp {
	width: 47%;

	height: 108px;
	margin: 6px 6px;
	margin-bottom: 2px;
}
.tbdh-spp {
	width: 50%;
	margin-right: 5px;
}
.tbdh-sp-img-left {
	width: 100%;
	height: 223px;
	border-radius: 8px;
}
.tbdh-sp-img-right {
	width: 100%;
	height: 110px;
	border-radius: 8px;
}
.fs-13 {
	font-style: 13px;
}
.fs-12 {
	font-style: 12px;
}
.ml-6 {
	margin-left: 6px;
}
.mr-6 {
	margin-right: 6px;
}
</style>
